import { useState, useEffect, Fragment } from "react";
import { Env } from "../../enviroment/environment";
import clientmanagmentObj from "../../services/client-managment.service";
import BoLoader from "../../helpers/BoLoader";
import RefreshToken from "../../helpers/RefreshToken";
import { Link } from "react-router-dom";
import ModelPopup from "../../helpers/ModelPopup";
import TransferClient from "../superadmin/TransferClient";
import { haspermissions } from "../permissions/PermissionTypes";
import AddSuperClient from "../superclient/AddSuperClient";
import SearchGridSuperClient from "./SearchGridSuperClient";
import AddClient from "../superadmin/AddClient";
import { useSelector } from "react-redux";
import AssociateSubClients from "./AssociateSubClients";
const API_URL = Env.ClientAdmin;

const SuperClients = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [confirmmodalShow, setCnfrmModalShow] = useState(false);
  const [Content, setContent] = useState();
  const [DataSuccessful, setDataSuccessful] = useState(false);
  const [boloader, setBoLoader] = useState(false);
  const [donutChart, setDonutChart] = useState();
  const [modalsuccessfullShow, setModalsuccessfullShow] = useState(false);
  const [modalShowTransferClient, setModalShowTransferClient] = useState(false);
  const [modelconfirmsuperclient, setModelconfirmsuperclient] = useState(false);
  const [modelconfirmassociateclient, setModelconfirmassociateclient] = useState(false);
  if (currentUser) {
    haspermissions.CreateClient =
      currentUser?.user?.Permissions?.includes("Create Client");
    haspermissions.LedgerTransfer =
      currentUser?.user?.Permissions?.includes("Ledger Transfer");
  }

  useEffect(() => {
    getCountDashboard();
  }, []);

  const getCountDashboard = () => {
    setBoLoader(true);
    setDataSuccessful(false);
    clientmanagmentObj.getclientcount().then(
      (response) => {
        setContent(response.data.payload.result);
        const lst_donutchart = {
          Active: response.data.payload.result.activeClient,
          Suspended: response.data.payload.result.inActiveClient,
        };
        setDonutChart(lst_donutchart);
        setDataSuccessful(true);
        setBoLoader(false);
      },
      (error) => {
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            window.location.reload();
            setBoLoader(false);
          } else {
            setBoLoader(false);
          }
        })();
      }
    );
  };
  const goToClients = () => {
    getCountDashboard();
  };
  return (
    <div className="col-xl-9 col-lg-12 bo-main-content">
      <BoLoader loading={boloader} />
      <div className="row mt-20">
        {haspermissions.CreateClient && (
          <Fragment>
          <div
            className="col-sm-6 col-md-3 col-xl-2"
            onClick={() => setCnfrmModalShow(true)}
          >
            <div className="col-stats col-stats-action mb-40 col-stats-mbl">
              <div data-bs-target="\clients" data-bs-toggle="modal">
                <span className="icon-add-client">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                </span>
                <br />
                <Link to="#" className="pt-3">
                  Create Client
                  <span className="icon-bo-arrow"></span>
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-sm-6 col-md-3 col-xl-2"
            onClick={() => setModelconfirmsuperclient(true)}
          >
            <div className="col-stats col-stats-action mb-40 col-stats-mbl">
              <div data-bs-target="\clients" data-bs-toggle="modal">
                <span className="icon-add-client">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                </span>
                <br />
                <Link to="#" className="pt-3">
                  Create Super Client
                  <span className="icon-bo-arrow"></span>
                </Link>
              </div>
            </div>
          </div>
          <div
            className="col-sm-6 col-md-3 col-xl-2"
            onClick={() => setModelconfirmassociateclient(true)}
          >
            <div className="col-stats col-stats-action mb-40 col-stats-mbl">
              <div data-bs-target="\clients" data-bs-toggle="modal">
                <span className="icon-add-client">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                </span>
                <br />
                <Link to="#" className="pt-3">
                  Associate Clients
                  <span className="icon-bo-arrow"></span>
                </Link>
              </div>
            </div>
          </div>
          </Fragment>
          
        )}
        {haspermissions.LedgerTransfer && (
          <div
            className="col-md-3 col-sm-6 col-xl-2"
            onClick={() => setModalShowTransferClient(true)}
          >
            <div className="col-stats col-stats-action mb-40">
              <div>
                <span className="icon-load-card">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                  <span className="path10"></span>
                  <span className="path11"></span>
                  <span className="path12"></span>
                  <span className="path13"></span>
                  <span className="path14"></span>
                </span>
                <br />
                <Link to="#" className="mt-3">
                  Ledger Transfer
                  <span className="icon-bo-arrow"></span>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
      {DataSuccessful && (
        <Fragment>
          <SearchGridSuperClient
            methodname="getclients"
            placeholdervalue="Search Super Client"
            headersdata={[
              "LOGO",
              "SUPER CLIENT NAME",
              // "REG. DATE",
              "EMAIL",
              // "PHONE NUMBER",
               "EDIT",
              // "VIEW",
            ]}
            apiurl={API_URL}
            screenname="clients"
            createclientpermission={haspermissions.CreateClient}
          />
        </Fragment>
      )}

    
      {haspermissions.CreateClient && (
        <AddSuperClient
          show={modelconfirmsuperclient}
          onHide={() => setModelconfirmsuperclient(false)}
          onAddClient={() => {
            setModelconfirmsuperclient(false);
            setModalsuccessfullShow(true);
          }}
        />
      )}
        {haspermissions.CreateClient && (
        <AssociateSubClients
          show={modelconfirmassociateclient}
          onHide={() => setModelconfirmassociateclient(false)}
          onAddClient={() => {
            setModelconfirmassociateclient(false);
            setModalsuccessfullShow(true);
          }}
        />
      )}
        {haspermissions.CreateClient && (
        <AddClient
          show={confirmmodalShow}
          onHide={() => setCnfrmModalShow(false)}
          onAddClient={() => {
            setCnfrmModalShow(false);
            setModalsuccessfullShow(true);
          }}
        />
      )}


      <TransferClient
        show={modalShowTransferClient}
        onHide={() => setModalShowTransferClient(false)}
      />
      <ModelPopup
        key={5}
        show={modalsuccessfullShow}
        onHide={() => setModalsuccessfullShow(false)}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-42"
        backdrop="static"
        keyboard={false}
        modelbody={[
          <Fragment>
            <div className="row">
              <div className="col-md-12">
                <div className="icon-alert icon-alert-popup">
                  <span className="icon-successful">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <h2>Successful</h2>
                <div className="mt-16">
                  <div>
                    <form>
                      <div className="row">
                        <div className="col-md-12">
                          <p>Client Added Successfully</p>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group submit-field mt-40 mb-0">
                            <Link
                              to="#"
                              className="btn btn-large w-100"
                              onClick={() => {
                                setModalsuccessfullShow(false);
                                goToClients();
                              }}
                            >
                              Done
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>,
        ]}
      />
    </div>
  );
};

export default SuperClients;
